module.exports = __webpack_public_path__ + "static/img/weather_031.5dccbd2a.svg";